import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { fetchAddRssFeedSubmission } from 'modules/posts/actions';
import AddRssFeedComponent from 'modules/posts/components/AddRssFeedComponent';
import { fileUploaderIsolatedFileTypeEnum } from 'modules/common/enums';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const AddRssFeedContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [formFieldsValues, setFormFieldsValues] = useState({
    link: '',
    frequency: '0',
    topic: [],
    readImage: true,
    forceOpenGraph: false,
    media: {
      totalCompressedFilesSize: 0,
      uploadedFiles: [],
    },
  });
  const [formFieldsValidation, setFormFieldsValidation] = useState({
    link: true,
    topic: true,
    media: true,
  });
  const [uploadMediaErrorMessage, setUploadMediaErrorMessage] = useState('');
  const [shouldShowErrorMessage, setShouldShowErrorMessage] = useState(false);
  const [isPreviewFilePopupOpen, setIsPreviewFilePopupOpen] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState('');
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  const addRssFeedSuccessCallback = () => {
    navigate('/rssFeed');
  };

  const addRssFeedFailCallback = () => {
    setShouldShowErrorMessage(true);
  };
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleTextInputFieldChange = (fieldName, fieldEvent) => {
    const { value } = fieldEvent.target;

    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = value;

      return fieldsObj;
    });
  };

  const handleMultiSelectionDropdownFieldChange = (fieldName, fieldValue) => {
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = fieldValue;

      return fieldsObj;
    });
  };

  const handleCheckboxFieldChange = fieldName => {
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = !prevValue[fieldName];

      return fieldsObj;
    });
  };

  const handleUploadFileChange = fileData => {
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj.media = fileData;

      return fieldsObj;
    });
  };

  const handleUploadFileErrorChange = errorMessage => {
    setUploadMediaErrorMessage(errorMessage);
  };

  const handlePreviewFileClick = (openPopup, fileData) => {
    if (fileData.fileTypeId === fileUploaderIsolatedFileTypeEnum.image) {
      if (openPopup) {
        setPreviewFileUrl(fileData.dataUrl);
        setIsPreviewFilePopupOpen(true);
      } else setIsPreviewFilePopupOpen(false);
    } else {
      window.open(fileData.windowUrl);
    }
    setUploadMediaErrorMessage('');
  };

  const handleDeleteFileIconClick = (event, index) => {
    if (event) event.stopPropagation();

    setFormFieldsValues(prevValue => {
      const fieldsObj = JSON.parse(JSON.stringify(prevValue));
      const uploadedFiles = [...fieldsObj.media.uploadedFiles];
      uploadedFiles.splice(index, 1);
      fieldsObj.media.uploadedFiles = uploadedFiles;

      return fieldsObj;
    });

    setUploadMediaErrorMessage('');
  };

  const handleAddRssFeedBtnClick = () => {
    let isFormValid = true;

    if (
      !formFieldsValues.link ||
      !formFieldsValues.topic.length ||
      !formFieldsValues.media.uploadedFiles.length
    ) {
      setFormFieldsValidation({
        link: !!formFieldsValues.link,
        topic: !!formFieldsValues.topic.length,
        media: !!formFieldsValues.media.uploadedFiles.length,
      });
      isFormValid = false;
    }

    if (isFormValid === false) return;

    setFormFieldsValidation({
      link: true,
      topic: true,
      media: true,
    });

    const body = {
      data: {
        channelLink: formFieldsValues.link,
        channelTopics: formFieldsValues.topic,
        channelMedia: formFieldsValues.media.uploadedFiles[0],
        forceOpenGraph: formFieldsValues.forceOpenGraph,
      },
      callbackActionSuccess: addRssFeedSuccessCallback,
      callbackActionFail: addRssFeedFailCallback,
    };

    dispatch(fetchAddRssFeedSubmission(body));
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <AddRssFeedComponent
      formFieldsValues={formFieldsValues}
      formFieldsValidation={formFieldsValidation}
      uploadMediaErrorMessage={uploadMediaErrorMessage}
      shouldShowErrorMessage={shouldShowErrorMessage}
      isPreviewFilePopupOpen={isPreviewFilePopupOpen}
      previewFileUrl={previewFileUrl}
      handleTextInputFieldChange={handleTextInputFieldChange}
      handleMultiSelectionDropdownFieldChange={handleMultiSelectionDropdownFieldChange}
      handleCheckboxFieldChange={handleCheckboxFieldChange}
      handleUploadFileChange={handleUploadFileChange}
      handleUploadFileErrorChange={handleUploadFileErrorChange}
      handlePreviewFileClick={handlePreviewFileClick}
      handleDeleteFileIconClick={handleDeleteFileIconClick}
      handleAddRssFeedBtnClick={handleAddRssFeedBtnClick}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

AddRssFeedContainer.propTypes = {};

AddRssFeedContainer.defaultProps = {};

export default AddRssFeedContainer;
